import { Component } from '@angular/core'

@Component({
  selector: 'lin-table-toolbar-button-row',
  template: ` <ng-content></ng-content> `,
  styleUrls: ['./table-toolbar-button-row.component.scss'],
  standalone: false,
})
export class TableToolbarButtonRowComponent {}
